import { get } from 'radash';
import { PermissionResource, PermissionType, ReviewPermissionType, UserRole, } from '../../models/index.js';
export function hasRole(requiredRole, user) {
    return hasRoleLevel(requiredRole, user.role);
}
export function hasRoleLevel(requiredRole, userRole) {
    return roleLevel(userRole) >= roleLevel(requiredRole);
}
export function hasPermission(projectId, requiredPermissions, user) {
    if (user.role === UserRole.ADMIN) {
        // Admin should have access to everything
        return true;
    }
    const userPermissions = user.permissions.find((permission) => permission.projectId === projectId);
    if (!userPermissions) {
        return false;
    }
    const hasAllPermissions = requiredPermissions.every((requiredPerm) => {
        const userPermission = get(userPermissions, requiredPerm.resource);
        if (!userPermission) {
            return false;
        }
        if (requiredPerm.resource === PermissionResource.REVIEW) {
            return (reviewPermissionLevel(userPermission) >=
                reviewPermissionLevel(requiredPerm.permission));
        }
        else {
            return (permissionLevel(userPermission) >=
                permissionLevel(requiredPerm.permission));
        }
    });
    return hasAllPermissions;
}
export function roleLevel(role) {
    switch (role) {
        case UserRole.ADMIN:
            return 1000;
        case UserRole.CESG:
            return 100;
        case UserRole.GUEST:
            return 10;
        default:
            return 0;
    }
}
export function permissionLevel(permission) {
    switch (permission) {
        case PermissionType.EDIT:
            return 10000;
        case PermissionType.COMMENT:
            return 1000;
        case PermissionType.VIEW:
            return 100;
        case PermissionType.DISABLED:
            return 10;
        default:
            return 0;
    }
}
export function rolesAtOrAbove(role) {
    return Object.values(UserRole).filter((candidate) => roleLevel(candidate) >= roleLevel(role));
}
function reviewPermissionLevel(permission) {
    switch (permission) {
        case ReviewPermissionType.ALLOWED:
            return 100;
        case ReviewPermissionType.PROHIBITED:
            return 10;
        default:
            return 0;
    }
}
export const roleMapper = (data, mapper) => {
    const sortedRoles = mapper.toSorted((a, b) => {
        return roleLevel(b.role) - roleLevel(a.role);
    });
    return (userRole) => {
        for (const { role, mapFn } of sortedRoles) {
            if (hasRoleLevel(role, userRole)) {
                return mapFn(data);
            }
        }
        return data;
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapRole = (role, mapFn) => ({
    role,
    mapFn,
});
